var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssets2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_1514)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9397 3.97391C20.0727 3.10693 18.7931 2.79872 17.6265 3.17589C14.2802 4.2577 11.5554 6.71739 10.1379 9.93585L9.75822 10.7978C8.27392 10.6619 6.78862 11.2547 5.75471 12.2926C5.38161 12.6671 5.12087 13.0925 4.96813 13.3424L4.89072 13.4694C4.75342 13.6949 4.67282 13.8273 4.57186 13.9591C4.47408 14.0868 4.39789 14.1551 4.32399 14.2025C4.25353 14.2476 4.11837 14.3167 3.85335 14.3605C3.26966 14.4569 2.75859 14.8068 2.45754 15.3161C2.1565 15.8253 2.09637 16.4418 2.29333 16.9996C2.70523 18.1663 3.39525 19.2046 4.10199 19.9114C5.23887 21.0482 6.85944 21.4548 8.28921 21.3988C9.74922 21.3416 11.341 20.7961 12.5303 19.6068C13.708 18.4291 14.2502 16.9311 14.1626 15.4808L15.3985 14.8421C18.3476 13.3179 20.6274 10.7159 21.7735 7.60622C22.229 6.37022 21.9319 4.96607 20.9935 4.02766L20.9397 3.97391ZM13.6234 13.5081L14.4802 13.0653C16.9807 11.773 18.9216 9.56073 19.8969 6.91457C20.086 6.40138 19.9591 5.82166 19.5793 5.44187L19.5255 5.38812C19.1896 5.05219 18.6938 4.93277 18.2417 5.07891C15.4384 5.98519 13.1557 8.04577 11.9682 10.742L11.6697 11.4197C12.0165 11.6254 12.351 11.8838 12.6663 12.1991C13.064 12.5968 13.3831 13.0386 13.6234 13.5081ZM6.60778 14.4953C6.30547 14.9935 5.97278 15.5418 5.34654 15.9217C5.03876 16.1083 4.66008 16.2544 4.17924 16.3338C4.42528 17.0307 4.80657 17.6666 5.20204 18.1489C5.30651 18.2763 5.41197 18.3929 5.51619 18.4971C6.78314 19.7641 9.56855 19.7401 11.1161 18.1926C12.5216 16.7871 12.4791 14.8403 11.2521 13.6133C10.0251 12.3864 8.27334 12.5982 7.17164 13.7041C6.95734 13.9192 6.78795 14.1984 6.60778 14.4953Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1084_1514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets2D);
export default __webpack_public_path__ + "static/media/assets-2d.13b07cbe80b0208246e8c932cb97d058.svg";
export { ForwardRef as ReactComponent };